import React from 'react';
import {makeStyles} from '@material-ui/styles';
import {
    Card,
    CardContent,
    CardHeader,
    colors,
    Divider,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Theme,
    Typography
} from '@material-ui/core';
import {Role} from '../../../graphql/auth';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    card: {
        padding: 0,
    },
    divider: {
        //backgroundColor: colors.grey[300]
    },
    titleCell: {
        width: '40%',
    },
    dataCell: {
        width: '60%',
    },
    actions: {
        justifyContent: 'flex-end'
    },
    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        }
    }
}));

const RoleView = (props: { role: Role, }) => {
    const {role} = props;
    const classes = useStyles();

    return (
        <form>
            <Grid className={classes.root} container spacing={3}>

                <Grid item xs={12}>
                    <Typography variant="h2">Role: {role.name}</Typography>
                </Grid>
                <Grid item md={6} sm={12}>
                    <Card className={classes.card}>
                        <CardHeader title="Role Details"/>
                        <Divider/>
                        <CardContent className={classes.card}>
                            <Table className={classes.card}>
                                <TableBody>

                                    <TableRow>
                                        <TableCell>Name:</TableCell>
                                        <TableCell><Typography>{role.name}</Typography></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Active?:</TableCell>
                                        <TableCell><Typography>{role.active ? 'true' : 'false'}</Typography></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Ident:</TableCell>
                                        <TableCell><Typography>{role.ident}</Typography></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Description:</TableCell>
                                        <TableCell><Typography>{role.description}</Typography></TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item md={6} sm={12}>
                    <Card className={classes.card}>
                        <CardHeader title="Permissions"/>
                        <Divider/>
                        <CardContent className={classes.card}>
                            <Table className={classes.card}>
                                <TableBody>
                                    {role.permissions!.map((permission) => (
                                        <TableRow key={permission.ident}>
                                            <TableCell>{permission.name}</TableCell>
                                            <TableCell><Typography>{permission.description}</Typography></TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </form>
    );
};

export default RoleView;
